import { Routes } from "@angular/router";
import { LayoutComponent } from "./layouts/layout.component";
import { RouteGuardService } from "./core/services/route-guard/route-guard.service";
import { Page404Component } from "./pages-extra/page404/page404.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { ForcePasswordChangeGuard } from "./core/guards/force-password-change.guard";
import { PermissionRouteGuard } from "./core/guards/permission-route.guard";

export const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./account/account.module").then((m) => m.AccountModule),
  },
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [RouteGuardService, AuthGuard, ForcePasswordChangeGuard],
    canActivateChild: [PermissionRouteGuard],
  },
  {
    path: "pages",
    loadChildren: () =>
      import("./pages-extra/pages-extra.module").then(
        (m) => m.PagesExtraModule,
      ),
    canActivate: [],
  },
  { path: "**", component: Page404Component },
];
